<template lang="pug">
  v-dialog(:value="value" @input="close" max-width="600")
    v-card(v-if="value")
      validation-observer(ref="obs" v-slot="{ invalid, handleSubmit }")
        v-card-title Добавить файл
          v-spacer
          v-btn(@click="close" icon)
            v-icon mdi-close
        v-card-text
          validation-provider(
            rules="required"
            name="Название"
            vid="name"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="file.name"
              :error-messages="errors"
              label="Название файла"
              rounded filled
            )

          file-input(
            v-model="file.file_name"
            :url.sync="file.url"
            label="Файл к уроку"
            hint="Допустимые виды файлов: png, jpg, pdf, pptx, docx, doc. Максимальный размер 64 МБ"
            vid="file"
            name="Файл"
          )

        v-card-actions
          v-spacer
          v-btn(
            v-if="editData"
            color="success"
            :loading="loading"
            @click="handleSubmit(updateFile)"
            text
          ) Изменить
          v-btn(
            v-else
            color="success"
            :loading="loading"
            @click="handleSubmit(addFile)"
            text
          ) Добавить
          v-btn(color="warning" @click="close" text) Закрыть
</template>

<script>
import FileInput from '@/components/InputFields/FileInput.vue';

export default {
  name: 'AddFileDialog',
  components: {
    FileInput,
  },
  props: {
    value: { type: Boolean, default: false },
    lessonInstance: { type: Object, default: null },
    editData: { type: Object, default: null },
  },
  data() {
    return {
      file: {
        name: '',
        file_name: '',
      },
      loading: false,
    };
  },
  watch: {
    value(val) {
      if (val && this.editData) {
        this.file = { ...this.editData };
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
      this.file = {};
      this.$refs.obs.reset();
    },
    async addFile() {
      this.loading = true;
      try {
        if (this.lessonInstance) {
          const r = await this.$api.lessons.createFile(this.lessonInstance.id, this.file);
          this.file = r.data.data;
          this.loading = false;
          this.$emit('file:add', this.getItem());
          this.close();
        } else {
          this.$emit('file:add', this.getItem());
          this.close();
          this.loading = false;
        }
      } catch (e) {
        this.loading = false;
        console.log('Ошибка при загрузке файла', e);
      }
    },
    async updateFile() {
      this.loading = true;
      try {
        if (this.lessonInstance) {
          this.$rHandler(
            this.$api.lessons.updateFile(this.file.id, this.file),
            () => {
              this.loading = false;
              this.$emit('file:edit', this.getItem());
              this.close();
            },
            () => {
              this.loading = false;
            },
          );
        } else {
          this.$emit('file:edit', this.getItem());
          this.close();
          this.loading = false;
        }
      } catch (e) {
        this.loading = false;
        console.log('Ошибка при загрузке файла', e);
      }
    },
    getItem() {
      return { ...this.file };
    },
  },
};
</script>

<style scoped>

</style>
